import { Injectable } from '@angular/core';
import { CurrencyPipe, TitleCasePipe } from '@angular/common';
import { AppConfigService } from './app-config.service';
import { CONTRACT_TEMPLATE_TYPE } from './contract-template.service';

@Injectable()
export class DatasourceResolverService {

    constructor(
        private appConfig: AppConfigService,
        private currencyPipe: CurrencyPipe,
        private titleCasePipe: TitleCasePipe
    ) {}

    buyerName(property: Parse.Object, contractTemplate: Parse.Object) {
        if (contractTemplate.get('type') === CONTRACT_TEMPLATE_TYPE.OFFER) {
            return this.appConfig.parseConfig?.get('contractBusinessName');
        }

        return null;
    }

    address(property: Parse.Object) {
        let addressStr = '';

        if (property.get('address')) {
            addressStr += property.get('address') + ', ';
        }

        if (property.get('address2')) {
            addressStr += property.get('address2') + ', ';
        }

        if (property.get('city')) {
            addressStr += property.get('city') + ', ';
        }

        if (property.get('state')) {
            addressStr += property.get('state') + ' ';
        }

        if (property.get('zip')) {
            addressStr += property.get('zip');
        }

        return this.titleCasePipe.transform(addressStr);
    }

    county(property: Parse.Object) {
        return property.get('estatedInfo').get('parcel').county_name;
    }

    taxId(property: Parse.Object) {
        return property.get('estatedInfo').get('parcel').apn_original;
    }

    legalDescription(property: Parse.Object) {
        return property.get('estatedInfo').get('parcel').legal_description;
    }

    todaysDate() {
        const now = new Date();
        return now.toLocaleDateString();
    }

    balanceToClose(property: Parse.Object, contractTemplate: Parse.Object) {
        try {
            const diff = property.get('marketingPurchasePrice') - property.get('deposit');
            return this.currencyPipe.transform(diff, 'USD', 'symbol');
        } catch (error) {
            return null;
        }
    }

    nameOfCooperatingAgent(property: Parse.Object) {
        return this.titleCasePipe.transform(`${property.get('owner').get('firstname')} ${property.get('owner').get('lastname')}`);
    }

    nameOfListingAgent(property: Parse.Object, contractTemplate: Parse.Object) {
        if (contractTemplate.get('type') === CONTRACT_TEMPLATE_TYPE.OFFER) {
            return this.titleCasePipe.transform(property.get('listingAgent'));
        }

        return null;
    }

    nameOfListingBrokerage(property: Parse.Object, contractTemplate: Parse.Object) {
        if (contractTemplate.get('type') === CONTRACT_TEMPLATE_TYPE.OFFER) {
            return this.titleCasePipe.transform(property.get('listingOffice'));
        }

        return null;
    }
}
